export default __webpack_public_path__ + "text-width.png";